import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["tab"]
  static classes = ["selected"]

  select(event) {
    this.tabTargets.forEach((tab) => tab.classList.remove(...this.selectedClasses))
    event.currentTarget.classList.add(...this.selectedClasses)
  }
}
